import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgHeading2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M4 22V12M4 2v10m0 0h16m0-10v20"
	})
});
export default SvgKgHeading2;
